import { ChangeEvent, useCallback } from "react";

// Returns a callback that calls on change with the value from event.target.value
export default function useChangeCallback<
  T extends Element & { value: string }
>(onChange: (value: string) => void) {
  return useCallback((event: ChangeEvent<T>) => onChange(event.target.value), [
    onChange,
  ]);
}

// Same as above but allows for a casting function
export function useChangeCallbackWithCast<
  T extends Element & { value: string },
  V
>(onChange: (value: V) => void, cast: (value: string) => V) {
  return useCallback(
    (event: ChangeEvent<T>) => onChange(cast(event.target.value)),
    [onChange, cast]
  );
}
